import { GameObj, KAPLAYCtx, PosComp, SpriteComp, TimerComp } from "kaplay";
import { hiding_spots, Level, levels } from "./levels";
import { make_button, make_hint_cat, make_tutorial_cat } from "./ui";
import { furnish_house, make_house } from "./house";

const EATEN_MAP: { [k: string]: string } = {
    cat_food_dry: "dry_food_bowl",
    pumpkin: "pumpkin_seeds",
    water: "water_bowl",
    cat_food_wet: "wet_food_bowl",
};

const EATEN_SOUNDS: { [k: string]: string } = {
    cat_food_dry: "chomp",
    pumpkin: "eat_pumpkin",
    water: "slurp",
    cat_food_wet: "can",
};

function add_level(k: KAPLAYCtx, level: Level, id: number, levels_done: boolean[]) {
    make_house(k);
    furnish_house(k);
    let game_state = {
        solved: false,
    };
    let grid_corner = [
        16 * 14 - level.grid.width * 8,
        16 * 10 - level.grid.height * 8,
    ];
    const objects = [] as GameObj<SpriteComp | { my_grid_pos: number[] } | PosComp>[];
    const grid_obj = k.add([
        {
            grid: { items: level.grid.carpet.map(v => v.map(_ => "")), ...level.grid },
        },
    ]);
    function eat_obj(x: number, y: number, item: string) {
        if (item == "") {
            return;
        }
        let obj = objects.find(v => v.my_grid_pos[0] == x && v.my_grid_pos[1] == y);
        if (!obj) {
            return;
        }
        obj.sprite = EATEN_MAP[item.split(".")[0]];
        let original_pos = obj.pos;
        k.tween(0, 5, 0.9, v => {
            obj.pos = original_pos.add(k.vec2(0, -Math.floor(10 * (1 - Math.cos(5 * v)) * Math.exp(-v))));
        });
        let sound = EATEN_SOUNDS[item.split(".")[0]];
        if (sound) k.play(sound);
    }
    let trigger_win = async () => { };
    let check_win = () => { };
    for (let y = 0; y < level.grid.height; y++) {
        for (let x = 0; x < level.grid.width; x++) {
            if (level.grid.carpet[y][x])
                k.add([
                    k.sprite("carpet"),
                    k.pos(grid_corner[0] + 16 * x, grid_corner[1] + 16 * y),
                    k.layer("bg")
                ]);
        }
    }
    for (let i = 0; i < level.objects.length; i++) {
        let [original_x, original_y, layer] = hiding_spots[level.positions[i]];
        const new_obj = k.add([
            k.sprite(level.objects[i].split(".")[0], { flipX: Math.random() > 0.5 }),
            k.pos(original_x, original_y),
            k.area(),
            k.layer(layer),
            {
                my_grid_pos: [] as number[],
                dragging: false,
            },
        ]);
        let press_event = k.onMousePress(() => {
            if (new_obj.isHovering() && !game_state.solved) {
                new_obj.dragging = true;
                if (new_obj.my_grid_pos.length != 0) {
                    grid_obj.grid.items[new_obj.my_grid_pos[1]][
                        new_obj.my_grid_pos[0]
                    ] = "";
                }
            }
        });
        let move_event = k.onMouseMove(() => {
            if (new_obj.dragging) {
                new_obj.moveTo(k.mousePos().x - 8, k.mousePos().y - 8);
            }
        });
        let mouse_up_event = k.onMouseRelease(() => {
            if (new_obj.dragging) {
                new_obj.dragging = false;
                let x = Math.floor((k.mousePos().x - grid_corner[0]) / 16);
                let y = Math.floor((k.mousePos().y - grid_corner[1]) / 16);
                if (
                    x >= 0 &&
                    x < level.grid.width &&
                    y >= 0 &&
                    y < level.grid.height &&
                    grid_obj.grid.carpet[y][x] &&
                    (grid_obj.grid.items[y][x] == "" || new_obj.my_grid_pos.length == 2)
                ) {
                    // Swap!!
                    if (grid_obj.grid.items[y][x] != "" && new_obj.my_grid_pos.length == 2) {
                        // Move replacing item to dragging items spot
                        let dragging_spot = new_obj.my_grid_pos;
                        grid_obj.grid.items[dragging_spot[1]][dragging_spot[0]] = grid_obj.grid.items[y][x];
                        let replacing_item = objects.find(o => o.my_grid_pos[0] == x && o.my_grid_pos[1] == y)!;
                        let new_pos = k.vec2(16 * dragging_spot[0] + grid_corner[0], 16 * dragging_spot[1] + grid_corner[1]);
                        let dist = new_pos.dist(replacing_item.pos);
                        k.tween(replacing_item.pos, new_pos, dist / 200, pos => replacing_item.moveTo(pos));
                        replacing_item.my_grid_pos = dragging_spot.slice();
                    }
                    grid_obj.grid.items[y][x] = level.objects[i];
                    new_obj.moveTo(x * 16 + grid_corner[0], y * 16 + grid_corner[1]);
                    new_obj.my_grid_pos = [x, y];
                    check_win();
                } else {
                    let dist = Math.sqrt((new_obj.pos.x - original_x) ** 2 + (new_obj.pos.y - original_y) ** 2);
                    k.tween(k.vec2(new_obj.pos), k.vec2(original_x, original_y), dist / 200, p => { new_obj.moveTo(p) });
                }
            }
        });
        new_obj.onDestroy(() => {
            press_event.cancel();
            move_event.cancel();
            mouse_up_event.cancel();
        });
        objects.push(new_obj);
    }
    if (id == 0) {
        make_tutorial_cat(k)
    }
    else {
        make_hint_cat(k, level.hint);
    }
    let cat = k.add([
        k.sprite("cat1", { anim: "sleep" }),
        k.pos(170, 42),
        k.layer("ui"),
    ]);
    let text_box_obj = k.add([
        k.sprite("text_box"),
        k.pos(116, 5),
        k.opacity(0),
        k.layer("top"),
    ]);
    let text_obj = k.add([
        k.text("I'm eepy", { size: 6, width: 76, font: "round" }),
        k.color(k.rgb(0, 0, 0)),
        k.pos(118, 9),
        k.opacity(0),
        k.layer("top"),
    ]);
    trigger_win = async () => {
        levels_done[id] = true;
        cat.play("walkForward");
        k.tween(cat.pos, k.vec2(grid_corner[0] - 24, grid_corner[1] - 16), 1.5, (v) => {
            cat.moveTo(v);
        });
        await k.wait(1.7);
        k.tween(1, 0, 1, o => {
            text_obj.opacity = o;
            text_box_obj.opacity = o;
        });

        for (let y = 0; y < level.grid.height; y += 2) {
            cat.play("walkLeft");
            cat.flipX = true;
            k.tween(
                cat.pos,
                k.vec2(grid_corner[0] - 8 + 16 * level.grid.width, cat.pos.y),
                1,
                (v) => cat.moveTo(v)
            );
            await k.wait(0.1);
            for (let x = 0; x < level.grid.width + 1; x += 1) {
                eat_obj(x, y, grid_obj.grid.items[y][x]);
                await k.wait(1 / (level.grid.width + 1));
            }
            if (y != level.grid.height - 1) {
                cat.play("walkForward");
                k.tween(cat.pos, k.vec2(cat.pos.x, cat.pos.y + 16), 0.2, (v) =>
                    cat.moveTo(v)
                );
                await k.wait(0.25);
                cat.play("walkLeft");
                cat.flipX = false;
                k.tween(cat.pos, k.vec2(grid_corner[0] - 24, cat.pos.y), 1, (v) =>
                    cat.moveTo(v)
                );
                await k.wait(0.1);
                for (let x = level.grid.width - 1; x >= -1; x -= 1) {
                    eat_obj(x, y + 1, grid_obj.grid.items[y + 1][x]);
                    await k.wait(1 / (level.grid.width + 1));
                }
                if (y != level.grid.height - 2) {
                    cat.play("walkForward");
                    k.tween(cat.pos, k.vec2(cat.pos.x, cat.pos.y + 16), 0.3, (v) =>
                        cat.moveTo(v)
                    );
                    await k.wait(0.25);
                }
            }
        }
        cat.play("sitForward");
        if (id == levels.length - 1) {
            make_button(k, () => k.go("home"), 120, 20, 180, 125, "Thanks for playing!", { outline: 1 });
        }
        else {
            make_button(k, () => k.go("game", id + 1), 40, 20, 220, 125, "Next", { outline: 1 });
        }
    }
    check_win = () => {
        let obj_count = grid_obj.grid.items
            .map((v) => v.map((i) => (i == "" ? 0 : 1) as number).reduce((a, b) => a + b))
            .reduce((a, b) => a + b);
        if (obj_count == level.objects.length) {
            text_box_obj.opacity = 1;
            text_obj.opacity = 1;
            for (let i = 0; i < level.rules.length; i++) {
                if (level.rules[i].condition(grid_obj.grid.items) == false) {
                    text_obj.text = level.rules[i].name;
                    return;
                }
            }
            game_state.solved = true;
            text_obj.text = "NOM NOM NOM";
            k.play("meow_win");
            trigger_win();
        } else {
            text_obj.text = "ZZZzzzzzz ZZZzzz";
        }
    }
}

export default add_level;
